import { Base } from "@dojo/framework/core/meta/Base";
import { IRotateResult } from "../../interfaces/meta/RotateResult";
import { PageObjectType } from "../../interfaces/model/Types";
import { controller, emptyResults, IDragResults } from  "./index";

/**
 * Customizing Drag meta to add key events in Drag result
 * Reference: https://github.com/dojo/widget-core/blob/master/src/meta/Drag.ts
 */
export class CsiDrag extends Base {
	/** Bound invalate method */
	private _boundInvalidate: () => void = this.invalidate.bind(this);

	/**
     * Get drag information for given  node key
     * @param key The key to node
     * @returns Drag result
     */
	public get(key: string | number, type?: string): Readonly<IDragResults> {
		const node = this.getNode(key) as HTMLElement;

		// if we don't have a reference to the node yet, return an empty set of results
		if (!node) {
			return emptyResults;
		}

		// otherwise we will ask the controller for our results
		return controller.get(node, this._boundInvalidate, type);
	}

	/**
     * Remove the context from drag listeners
     * @param key The key to node
     */
	public remove(key: string | number) {
		const node = this.getNode(key) as HTMLElement;

		// if we don't have a reference to the node yet, do nothing.
		// This case should not occur, however, if exists then preventive mechanism.
		if (!node) {
			return;
		}
		// otherwise we will ask the controller to remove the node for listening purpose
		controller.remove(node);
	}

	/**
     * Get rotation infromation for given node key
     * @param key The key to node
     * @param pageObject The page object
     *
     * FIXME: Rotation is not working with this for second attempt. Have to check logic behind it.
     * For now, keeping the meta based code and its flow. And, keeping older code in selection box until this is fixed.
     */
	public getRotation = (key: string | number, pageObject: PageObjectType): Readonly<IRotateResult> =>
		controller.getRotation(this.getNode(key) as HTMLElement, pageObject, this._boundInvalidate);
};

export default CsiDrag;
